// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"187":"120835217e5da3319adc","976":"aa2003275a3420f8ed27"}[chunkId] + ".css";
};